import { useRouter } from 'next/router';
import { UseFormGetValues } from 'react-hook-form';

import { useEffect } from 'react';

import { FormValues } from 'components/PostForm/PostForm';
import { DraftPost, useGlobalState } from 'components/new/providers/GlobalStateProvider';

export function useDraftPersistence(
  getValues: UseFormGetValues<FormValues>,
  selectedSpaceId: string,
  isEdit: boolean,
  tiptapEditorEnabled: boolean
) {
  const router = useRouter();
  const { createOrUpdateDraftPost } = useGlobalState();

  const saveDraft = (spaceId?: string) => {
    if (!tiptapEditorEnabled || isEdit) return;
    const formValues = getValues();
    const attachments = formValues.attachments?.filter((a) => !a.isLoading) || [];

    createOrUpdateDraftPost({
      ...formValues,
      attachments,
      draftId: spaceId || selectedSpaceId,
      spaceId: spaceId || selectedSpaceId,
    } as DraftPost);
  };

  // Save on route change
  useEffect(() => {
    const handleRouteChange = () => saveDraft(selectedSpaceId);
    router.events?.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events?.off('routeChangeStart', handleRouteChange);
    };
  }, [selectedSpaceId, getValues]);

  // Save on component unmount
  useEffect(() => {
    return () => {
      saveDraft();
    };
  }, []);

  return { saveDraft };
}
